/* Service Worker kayıt yardımcı. */

export const registerSW = () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
      // güncelleme kontrolü
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            // yeni sürüm hazır — sessizce devral
            nw.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });
    } catch (e) {
      // sessiz geç
    }
  });
};
